import { Controller } from 'stimulus'


export default class extends Controller {

    initialize() {
    }

    connect () {


        let options = {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: 0
        }

        document.querySelector('.footer-logo').classList.add('js-hidden')
        
        this.observer = new IntersectionObserver((entries) => {
            const ratio = entries[0].intersectionRatio;

            const logo = document.querySelector('.footer-logo')

            if (logo) {

                if (ratio === 0) {
                    logo.classList.add('js-hidden') 
                }

                if (ratio !== 0) {
                    logo.classList.remove('js-hidden')
                }
            }
        }, options);
        
        const element = document.querySelector('.trigger-logoFooter')
        this.observer.observe(element);
    }

    disconnect () {
    }

  }